import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {DataService} from '@app/services/data.service';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authenticationService: DataService,
              private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.authenticationService.token) {
      return next.handle(req);
    }
    const dup = req.clone({headers: req.headers.append('x-access-token', this.authenticationService.token)});
    return next.handle(dup).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          if (!body.success && body.error && (body.error.error === 'EXPIRED_TOKEN' || body.error.error === 'MISSING_TOKEN')) {
            this.router.navigate(['login'], {queryParams: {error: 'Session expired, please login to continue'}});
            this.authenticationService.logout();
          }
        }
      }, error => {
        // http response status code
        console.error(error.status);
        console.error(error.message);
      })
    );
  }
}
